import ConfiguratorNavigation from './configurator/configurator-navigation';
import ConfiguratorLeasing from './configurator/configurator-leasing';
import ConfiguratorApparat from './configurator/configurator-apparat';
import ConfiguratorSoftwareSelect from './configurator/configurator-software-select';

(function(){
    const configuratorNavigation = new ConfiguratorNavigation;
    configuratorNavigation.init();

    const leasingOptions = new ConfiguratorLeasing();
    leasingOptions.init();

    const configuratorApparat = new ConfiguratorApparat();
    configuratorApparat.init();

    const configuratorSoftwareSelect = new ConfiguratorSoftwareSelect();
    configuratorSoftwareSelect.init();

}());
